const COMPONENT_NAME = "ordersAndReturns";
export {
  COMPONENT_NAME
};
